import template from './uc-free-products-page.html.twig';
import './uc-free-products-page.scss';

Shopware.Component.register('uc-free-products-page', {
    template,

    methods: {
        goToConfig() {
            this.$router.push({ name: 'sellops.ultimate.cart.config' });
        },
    },
});
